(function () {
  function filterFacetList(input) {
    const fieldset = input.closest('fieldset');
    if (!fieldset) return;

    const parentDisplay = fieldset.closest('.parent-display');
    const showMoreButton = parentDisplay ? parentDisplay.querySelector('show-more-button') : null;
    const term = input.value.trim().toLowerCase();
    const items = fieldset.querySelectorAll('li.facets__item');

    items.forEach((item) => {
      const labelEl = item.querySelector('.facet-checkbox__text-label');
      const text = labelEl ? labelEl.textContent.trim().toLowerCase() : '';
      const matches = text.includes(term);

      if (term === '') {
        // Clearing the search resets the list back to its default collapsed state.
        if (item.classList.contains('show-more-item')) {
          item.classList.add('hidden');
        } else {
          item.classList.remove('hidden');
        }
      } else {
        item.classList.toggle('hidden', !matches);
      }
    });

    if (showMoreButton) {
      showMoreButton.classList.toggle('hidden', term !== '');
    }
  }

  // Capture phase, so this runs before facets.js's bubble-phase listener on
  // the <form> (see facets.js: facetForm.addEventListener('input', ...)).
  // Without stopping propagation here, typing in the search box triggers
  // Dawn's own debounced product-grid refetch, which replaces the filter
  // <fieldset> (search input included) with fresh unfiltered server HTML,
  // wiping out whatever was typed.
  document.addEventListener(
    'input',
    function (event) {
      if (event.target.matches('[data-facet-search]')) {
        event.stopPropagation();
        filterFacetList(event.target);
      }
    },
    true
  );
})();
